module.exports = __webpack_public_path__ + "img/event_day1_1000.9fbd2538.png";